export default "__VITE_ASSET__DW8D_6nT__"